import {
  FinanceRouteNames,
  LessonsRouteNames,
  OrganizationRouteNames,
  RouteNames,
  WorkoutRouteNames,
} from '../../route-names';
import { Permission, SystemPermission } from '../../types/permission';

export type MenuItem = {
  name: string;
  authenticated: boolean;
  path: string;
  permission?: Permission;
  icon?: string;
  className?: string;
  blank?: boolean;
};

export const MENU_ITEMS: MenuItem[] = [
  {
    path: RouteNames.HOME,
    name: 'menu.navigation.home',
    authenticated: true,
  },
];

export const DROPDOWN_MENU_ITEMS: MenuItem[] = [
  {
    name: 'menu.navigation.lessons',
    path: [RouteNames.ADMIN, LessonsRouteNames.LESSONS].join('/'),
    authenticated: true,
  },
  {
    name: 'menu.navigation.workouts',
    path: [RouteNames.ADMIN, WorkoutRouteNames.WORKOUTS].join('/'),
    authenticated: true,
  },
  {
    name: 'menu.navigation.finance',
    path: [RouteNames.ADMIN, FinanceRouteNames.FINANCE].join('/'),
    authenticated: true,
    permission: SystemPermission.Admin,
  },
  {
    name: 'menu.navigation.companies',
    path: OrganizationRouteNames.LIST,
    authenticated: true,
    permission: SystemPermission.SuperAdmin,
  },
  {
    name: 'menu.navigation.companyManagement',
    path: OrganizationRouteNames.DETAILS,
    authenticated: true,
  },
];
